import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Box, 
  IconButton,
  Typography,
  Stack,
  Paper,
  CircularProgress,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import PageTitle from '../../components/PageTitle';

const StoreResultsPage = () => {
  const navigate = useNavigate();
  const { storeId } = useParams();
  const [loading, setLoading] = useState(true);
  const [store, setStore] = useState(null);
  const [results, setResults] = useState([]);
  const [usersMap, setUsersMap] = useState({});

  useEffect(() => {
    // Mock data loading
    const loadData = () => {
      // Mock store data
      const mockStore = {
        id: storeId,
        name: 'Warpig Games',
        location: 'Palermo, Buenos Aires',
      };

      // Mock users map for player names
      const mockUsersMap = {
        1: 'Juan Pérez',
        2: 'Ana García',
        3: 'Carlos López',
        4: 'María Rodríguez',
        5: 'Diego Sánchez',
        6: 'Laura Torres',
      };

      // Mock results data
      const mockResults = [
        {
          id: 1,
          match_date: '2024-03-20T15:30:00',
          team1: {
            players: [{ user_id: 1 }],
            score: 3,
          },
          team2: {
            players: [{ user_id: 2 }],
            score: 1,
          },
        },
        {
          id: 2,
          match_date: '2024-03-19T18:00:00',
          team1: {
            players: [
              { user_id: 3 }, 
              { user_id: 4 }
            ],
            score: 2,
          },
          team2: {
            players: [
              { user_id: 5 }, 
              { user_id: 6 }
            ],
            score: 3,
          },
        },
        {
          id: 3,
          match_date: '2024-03-19T16:00:00',
          team1: {
            players: [{ user_id: 1 }],
            score: 2,
          },
          team2: {
            players: [{ user_id: 3 }],
            score: 0,
          },
        },
        {
          id: 4,
          match_date: '2024-03-18T19:30:00',
          team1: {
            players: [
              { user_id: 2 }, 
              { user_id: 5 }
            ],
            score: 3,
          },
          team2: {
            players: [
              { user_id: 4 }, 
              { user_id: 6 }
            ],
            score: 2,
          },
        }
      ];

      setStore(mockStore);
      setUsersMap(mockUsersMap);
      setResults(mockResults);
      setLoading(false);
    };

    loadData();
  }, [storeId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress sx={{ color: '#c89e38' }} />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <IconButton 
          onClick={() => navigate(`/torneos/tiendas/${storeId}`)}
          sx={{ 
            width: 40,
            height: 40,
            bgcolor: 'action.hover',
            color: 'text.primary',
            '&:hover': { 
              bgcolor: '#c89e38',
              color: 'white',
              transform: 'scale(1.1)'
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <PageTitle title={`Partidas - ${store.name}`} />
          <Typography variant="subtitle1" color="text.secondary">
            {store.location}
          </Typography>
        </Box>
      </Box>

      <Stack spacing={2}>
        {results.map((match) => (
          <Paper
            key={match.id}
            elevation={0}
            sx={{
              p: 2,
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {new Date(match.match_date).toLocaleDateString()}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
              <Box>
                <Typography variant="h4" fontWeight="bold" color="primary">
                  {match.team1.score}
                </Typography>
                <Typography variant="body1">
                  {match.team1.players.map(p => usersMap[p.user_id]).join(', ')}
                </Typography>
              </Box>
              <Typography variant="h6" color="text.secondary">VS</Typography>
              <Box>
                <Typography variant="h4" fontWeight="bold" color="primary">
                  {match.team2.score}
                </Typography>
                <Typography variant="body1">
                  {match.team2.players.map(p => usersMap[p.user_id]).join(', ')}
                </Typography>
              </Box>
            </Box>
          </Paper>
        ))}
      </Stack>
    </Container>
  );
};

export default StoreResultsPage; 